var _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInprogress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    stroke: "#FEA732",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.91683,
    cy: 15.4166,
    r: 2.08333,
    fill: "#FEA732"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.4168,
    cy: 15.4166,
    r: 2.08333,
    fill: "#FEA732"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.9168,
    cy: 15.4166,
    r: 2.08333,
    fill: "#FEA732"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInprogress);
export default __webpack_public_path__ + "static/media/inprogress.6adcd97b4cc0acc0e3369ce18d654d20.svg";
export { ForwardRef as ReactComponent };